<div *ngIf="config" class="license-details-container">
    <p-card>
        <div class="basin-display-flex basin-align-items-center">
            <div class="license-left-section">
                <span
                    class="organization-icon basin-display-flex basin-align-items-center basin-justify-content-center">
                    <svg width="54" height="54" viewBox="0 0 54 54" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M29.3501 0.103888C14.4989 -1.19274 1.40657 9.79861 0.103937 24.6498C-1.19269 39.5011 9.79264 52.5994 24.6499 53.8961C39.5011 55.1927 52.5994 44.2073 53.8961 29.3501C55.1927 14.4989 44.2074 1.40652 29.3501 0.103888ZM17.0742 45.612C10.8672 45.0658 8.12984 41.2779 6.79719 39.0268C0.139955 27.8854 3.78373 13.4544 14.9251 6.80315C18.4008 4.73214 22.3447 3.58558 26.3907 3.48954C26.1086 3.58558 23.2452 5.14634 22.885 9.30637C22.5428 13.2143 24.968 16.774 26.901 20.2137C27.3932 21.1021 27.8554 21.9245 28.4437 22.963C30.0285 25.7664 31.7333 29.5542 31.3791 33.6242C30.7428 40.8877 24.3437 46.2603 17.0802 45.63L17.0742 45.612ZM35.269 40.6956C34.7228 46.9087 29.2841 50.5884 23.1791 50.0542C21.7685 49.9281 20.3818 49.622 19.0491 49.1357C26.6728 48.7516 33.0659 43.2529 34.5907 35.7732C35.179 37.34 35.4131 39.0268 35.263 40.6956H35.269ZM50.4324 29.038C50.2523 31.139 49.7901 33.204 49.0517 35.179C49.3398 31.7453 48.0612 23.8634 40.7377 18.0226C40.2454 17.6264 38.9488 16.5999 37.9703 15.8135C34.3746 12.9501 31.5412 11.1433 31.7873 8.33389C31.9494 6.61105 33.4741 5.35044 35.197 5.51252C35.233 5.51252 35.269 5.51852 35.305 5.52453C38.7387 5.82467 42.4365 9.25234 42.4365 9.25234C48.1033 14.1987 51.0687 21.5463 50.4324 29.038Z"
                            fill="white" />
                    </svg>

                </span>
            </div>
            <div class="license-right-section">
                <div
                    class="license-right-top basin-mb-2 basin-align-items-center basin-display-flex basin-justify-content-space-between">
                    <div class="license-right-top-left">
                        <h4>{{config.title}}</h4>
                    </div>
                    <div
                        class="license-right-top-right basin-align-items-center basin-display-flex basin-justify-content-space-end">
                        @if(config.isLicenseStatusVisible) {
                        <p-inputSwitch [(ngModel)]="config.active" [disabled]="config.active" (onChange)="onAction('toggle', config.id)"
                            ariaLabel="License Status" />
                        <span class="basin-ml-2 p-button-label">Is License Active</span>
                        }
                        @if(config.isUpgradeLicenseVisible) {
                        <button type="button" class="p-element p-button p-button-text basin-ml-4"
                            (click)="onAction('edit', config.id)" [ngClass]="{ 'p-disabled': config.isEditDisabled }">
                            <span class="p-button-icon p-button-icon-left icon-edit" aria-hidden="true"></span>
                            <span class="p-button-label">Upgrade Tier</span>
                        </button>
                        }
                        @if(config.isRenewalVisible) {
                        <button type="button" class="p-element p-button p-button-text basin-ml-4"
                            (click)="onAction('edit', config.id)" [ngClass]="{ 'p-disabled': config.isEditDisabled }">
                            <span class="p-button-icon p-button-icon-left icon-edit" aria-hidden="true"></span>
                            <span class="p-button-label">Pending for Renewal</span>
                        </button>
                        }
                        @if(config.isDeleteVisible) {
                        <button type="button" class="p-element p-button p-button-text basin-ml-4"
                            (click)="onAction('delete', config.id)">
                            <span class="p-button-icon p-button-icon-left icon-delete" aria-hidden="true"></span>
                            <span class="p-button-label">Delete</span>
                        </button>
                        }
                    </div>
                </div>
                <div class="license-right-bottom">
                    <ul class="license-details-list">
                        @for(item of config.detailsItems; track item.name) {
                        <li class="license-details-list-item"
                            [ngClass]="{ 'license-notes': item.iconName === 'icon-sticky-note-2' }">
                            <span class="icon-container {{ item.iconName }}"></span> {{ item.name }} &nbsp;                      
                            <span *ngIf="item['iconName'] == 'icon-how-to-reg'"> User slots available</span>
                            <span *ngIf="item['iconName'] == 'icon-terrain'">sq km tier limit</span>
                            <span *ngIf="item['iconName'] == 'icon-landscape'">sq km available</span>
                        </li>
                        }
                    </ul>
                </div>
            </div>
        </div>
    </p-card>
</div>